/**
 * @file: 商品cube注册
 * @author: xiaolong.huang@dmall.com
 */

import { Cube } from '../../cube/core/cube';
import * as Update from '../../update/index';
import * as GoodsRenderCore from './renderCore';
import ForceUpdate from './forceUpdate';
import tpl from './goodsTpl';
import init from './init';
import render from './render';
import destroy from './destroy';

function registGoodsCube(params?: FreeObjMap): void {
    Cube.registCube({
        cubeName: 'shelvesbuild-e-g-default',
        behavior: {
            tpl: $(tpl),
            init: function () {
                init(this);
            },
            render: function () {
                render(this);
            },
            update: function (forceUpdate?: boolean): void {
                this.jView.removeClass('is-hide');
                if (forceUpdate) {
                    ForceUpdate(this);
                }
                else {
                    Update.updateDepByCubeId(this.id);
                }
            },
            destroy: function () {
                destroy(this);
            }
        }
    });
}

export default registGoodsCube;
